module.exports = __webpack_public_path__ + "img/43_72.05e5b02c.png";